// Client-side auth field validation, kept in ONE place so every form (register,
// login, reset, change-password) agrees and the bounds mirror the server schemas
// (routers/auth.py: EmailStr, password Field(min_length=8, max_length=256), name
// max_length=200). These are a UX + anti-abuse first line — the cheap rejection
// for "paste an entire book into the password field" — NOT the security boundary;
// the server re-validates every field and MaxBodySizeMiddleware caps the body.
import { isEmail } from './errors';

// email-validator (the server's EmailStr) bounds an address at 254 chars (RFC 5321).
export const EMAIL_MAX_LENGTH = 254;
export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 256;
export const NAME_MAX_LENGTH = 200;

/** A format + length check for an email field, or undefined when valid. */
export function emailError(value: string): string | undefined {
  const v = value.trim();
  if (!isEmail(v)) return 'Enter a valid email.';
  if (v.length > EMAIL_MAX_LENGTH) return `Email must be ${EMAIL_MAX_LENGTH} characters or fewer.`;
  return undefined;
}

/** A length check for a NEW password (min + max), or undefined when valid. */
export function passwordError(value: string): string | undefined {
  if (value.length < PASSWORD_MIN_LENGTH) return `Use at least ${PASSWORD_MIN_LENGTH} characters.`;
  if (value.length > PASSWORD_MAX_LENGTH)
    return `Use ${PASSWORD_MAX_LENGTH} characters or fewer.`;
  return undefined;
}

/** An optional display name: bounded length only (empty is allowed). */
export function nameError(value: string): string | undefined {
  if (value.trim().length > NAME_MAX_LENGTH)
    return `Name must be ${NAME_MAX_LENGTH} characters or fewer.`;
  return undefined;
}
